"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16 5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1 0 .16.05.31.11.44H4.1l5 10h.01c.17.33.5.56.89.56s.72-.23.89-.56h.01l5-10h-.01c.06-.13.11-.28.11-.44z"];
//# sourceMappingURL=symbol-triangle-down.js.map